import { styled } from '@material-ui/core';

import { down } from '../../../assets/style/breakpointHelpers';
import { domTag } from '../styledFilter';

export const StepIndicatorRoot = styled('div')({
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	gap: '14px',
	padding: '20px 0 24px',
});

export const StepIndicatorTrack = styled('div')({
	display: 'grid',
	gridAutoFlow: 'column',
	gridAutoColumns: '1fr',
	gap: '10px',
	[down('sm')]: {
		gap: '6px',
	},
});

export const StepIndicatorSegment = styled(domTag('button', ['state']))(
	({ state }: { state: 'completed' | 'current' | 'upcoming' }) => ({
		'all': 'unset',
		'cursor': state === 'upcoming' ? 'default' : 'pointer',
		'display': 'flex',
		'flexDirection': 'column',
		'justifyContent': 'flex-end',
		'gap': '8px',
		'padding': '8px 0',
		'minHeight': '44px',
		'opacity': state === 'upcoming' ? 0.55 : 1,
		'transition': 'opacity 200ms ease',

		'&:focus-visible .bar': {
			outline: '2px solid var(--color-brand-primary)',
			outlineOffset: '2px',
		},

		'& .bar': {
			height: '4px',
			borderRadius: '999px',
			backgroundColor:
				state === 'current'
					? 'var(--color-brand-primary)'
					: state === 'completed'
						? 'var(--color-brand-accent)'
						: 'var(--color-border-default)',
			transition: 'background-color 250ms ease',
		},

		'& .meta': {
			display: 'flex',
			alignItems: 'center',
			gap: '8px',
			fontFamily: 'var(--font-family-medium)',
			fontSize: '11px',
			letterSpacing: 'var(--tracking-wider)',
			textTransform: 'uppercase',
			color:
				state === 'current'
					? 'var(--color-brand-primary)'
					: state === 'completed'
						? 'var(--color-text-secondary)'
						: 'var(--color-text-tertiary)',
		},

		'& .num': {
			width: '20px',
			height: '20px',
			borderRadius: '999px',
			display: 'inline-flex',
			alignItems: 'center',
			justifyContent: 'center',
			fontSize: '11px',
			fontFamily: 'var(--font-family-semibold)',
			border: '1px solid currentColor',
			color: 'inherit',
		},

		'& .num.completed': {
			border: 'none',
			backgroundColor: 'var(--color-brand-accent)',
			color: '#fff',
		},

		'& .num.current': {
			border: 'none',
			backgroundColor: 'var(--color-brand-primary)',
			color: '#fff',
		},

		[down('sm')]: {
			'& .label': {
				display: 'none',
			},
		},
	})
);
